import {useCallback} from 'react'
import {useFormContext} from 'react-hook-form'

import {useActionContext} from '../../contexts'
import type {OrderFormState} from '../../types'
import {WhatsNextModal} from './components/WhatsNextModal'
import type {Props} from './types'

export function OrderAction(props: Props) {
  const {widget_id, ...rest} = props

  switch (widget_id) {
    case 'ndd_order_button_widget': {
      return <WhatsNextModal {...rest} />
    }

    default: {
      return null
    }
  }
}

export const useOrderAction = (): VoidFunction => {
  const {handleSubmit} = useFormContext<OrderFormState>()

  const {onSubmit} = useActionContext()

  return useCallback(() => {
    void handleSubmit(data => {
      onSubmit(data)
    })()
  }, [handleSubmit, onSubmit])
}

export const useOrderActionNdd = (setOpen: (value: boolean) => void): VoidFunction => {
  return useCallback(() => {
    setOpen(true)
  }, [setOpen])
}
